export const SLIDE_NAME_FOR_SHARE = 'Slide';
export const SLIDE_SOCIAL_NAME_FOR_SHARE_VIEWER = 'Social Viewer Slide';
export const SLIDE_SOCIAL_NAME_FOR_SHARE_IF_VIEWER = 'Social IF Viewer Slide';
export const ORDER_NAME_FOR_SHARE = 'Order';
export const GROUP_NAME_FOR_SHARE = 'Group';
export const IF_SLIDE_NAME_FOR_SHARE = 'IF Slide';
export const IF_ORDER_NAME_FOR_SHARE = 'IF Order';
export const AI_MODEL_NAME_FOR_SHARE = 'AI Model';
